import axios     from 'axios';
import { jwtDecode } from 'jwt-decode';
import { history } from '../../history';

/* eslint-disable no-undef */
let apiUrl = process.env.REACT_APP_API_PATH_LOCAL;
/* eslint-enable no-undef */

if((window.location.href).includes('https://cafsindia.com')){
	/* eslint-disable no-undef */
	apiUrl = process.env.REACT_APP_API_PATH_LIVE;
	/* eslint-enable no-undef */
}
/* eslint-disable no-undef */
const encryptInfo = require('./encryption');
/* eslint-enable no-undef */
export function initData(proData,callback){
	return callback({
		proData:{
			method:'POST',
			url:null,
			token:null,
			frm:null,
			formData:null,
			rsltInfo:{
				sts:false,
				msg:'',
				rslt:[],
				error:[],
				header:[],
				token : '',
				// COMMON
				userCount:0,
				logSchema:[],
				mode:'',
				proMode:'',
				totalAvg:'',
				uploadId:[],
				updCount:0,
				reviewSchema : [],
				updRslt:[],
				canProcess:false,
				//REQUIRED FOR SEARCH
				loading:false,
				totalCount:0,
				searchValue:'',
				pageCount:1,
				perPage:10,
				sortBy:'_id',
				sortOrder:-1
			}
		},
		response:null,
		returnFrm:null
	});
}


//GET TOKEN AND DECODE
export async function getToken(reqToken,callback){
	let token = '';
	if(reqToken){
		token = reqToken;
	}else{
		token = localStorage.getItem('vaultToken');
	}
	if(token){
		try{
			let tokenString = token;
			await encryptInfo.decryptData(token,function(decryptRslt){
				tokenString = decryptRslt;
				let decodeVal = jwtDecode(tokenString);
				if(Date.now() <= decodeVal.exp * 1000){
					return callback({ token:token,decoded:decodeVal });
				}else{
					localStorage.clear();
					history.push('/login');
				}
			});
		}catch(e){
			localStorage.clear();
			history.push('/login');
			return callback(false);
		}
	}else{
		localStorage.clear();
		history.push('/login');
		// window.location.reload(true)
	}
}

//RETURN RESPONSE
export async function getRslt(proRslt,callback){
	let proData = proRslt.proData;
	let response = proRslt.response;
	let from     = proRslt.frm;

	let msg = 'Unable to process your request.';   
	if(from === 'rslt'){
		msg = 'No response from server. Please refresh and retry';
	}else if(from === 'invalid_formdata'){
		msg = 'Invalid form data check form data';
	}else if(from === 'invalid_frm'){
		msg = 'Unable to process your request. retry later';
	}

	let finalslt = proData.rsltInfo;
	if((response)&&(response.data)){
		await encryptInfo.decryptData(response.data,function(decryptRslt){
			let postRslt = decryptRslt;
			if(postRslt.send_to){
				if(postRslt.send_path==='/login'){
					localStorage.clear();
					history.push(postRslt.send_path);
				}else{
					history.push(postRslt.send_path);
				}
			}else{
				(async () => {
					Object.keys(finalslt).map(function(rsltKey) {
						if(postRslt[String(rsltKey)]){
							finalslt[String(rsltKey)] = postRslt[String(rsltKey)];
						}
						return true;
					});
				})();
				return callback(finalslt);
			}
		});
	}else{
		finalslt.msg = msg;
		finalslt.type = proData.frm;
		return callback(finalslt);
	}
}


//SENT POST / GET
export async function sendPost(proData,callback){
	let postData = {
		method:proData.method ? proData.method : 'POST',
		headers :{ 'Authorization':proData.token },
		url:apiUrl+proData.url
	};
	if(proData.formData){
		postData.data = proData.formData;
	}
	if(proData.formData){
		await encryptInfo.encryptData(proData.formData,async function(encryptRslt){
			postData.data = encryptRslt;
		});
	}
	await axios(postData).then(response => {
		let sendData = { proData:proData,response:response,frm:'rslt' };
		getRslt(sendData,function(postRslt){
			return callback(postRslt);
		});
	}).catch(function () {
		let sendData = { proData:proData,response:null,frm:'catch' };
		getRslt(sendData,function(postRslt){
			return callback(postRslt);
		});
	});
}
